module.exports = __webpack_public_path__ + "static/media/parts_02.ac5ab609.svg";